<template>
  <div class="supervisor-intro-view" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="独立设计师" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <div class="image-part">
      <img class="intro-img" src="../../assets/designer_intro.png">
    </div>
  </div>
</template>

<script>
  import Header from '../../components/header/Header'
  export default {
    name: 'SupervisorDesignerIntro',
    components: {
      'my-header': Header,
    },
    data () {
      return {
          isWechatBrowser:this.$verfyBrowserType()
      }
    },
    created(){

    },
    beforeMount () {
      document.title = this.$route.meta.title;
    },
    methods: {

    }
  }
</script>
<style lang="scss">
  .supervisor-intro-view{
    background: white;
  }
  .intro-img{
    width: 100%;
    display: block;
  }
</style>

